import svgPaths from "./svg-fung1zvh0p";

function Kvtmld5Ugkmgql9L8R() {
  return (
    <div className="absolute left-1/2 size-[20px] top-1/2 translate-x-[-50%] translate-y-[-50%]" data-name="kvtmld5ugkmgql9l8r 1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g id="kvtmld5ugkmgql9l8r 1">
          <path d={svgPaths.p37434900} fill="var(--fill-0, #101928)" id="Vector" />
          <path d={svgPaths.p215caa80} fill="var(--fill-0, #101928)" id="Vector_2" />
          <path d={svgPaths.p1c0b9b00} fill="var(--fill-0, #101928)" id="Vector_3" />
        </g>
      </svg>
    </div>
  );
}

export default function Border() {
  return (
    <div className="overflow-clip relative rounded-[4px] size-full" data-name="Border">
      <Kvtmld5Ugkmgql9L8R />
    </div>
  );
}
